import { useNavigate } from "react-router-dom";

import { useTranslation } from "@/core/i18n";
import ChevronLeft from "atoms/icon/icons/chevron_left.svg";
import TopNav from "@/molecules/navbars/TopNav";

export const CartTopNav = ({
  showNavbar,
  className,
}: {
  showNavbar: boolean;
  /** Extra classes for the nav root (e.g. grid placement on desktop). */
  className?: string;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!showNavbar) return null;

  return (
    <TopNav
      startIconSVG={ChevronLeft}
      onStartIconClick={() => {
        navigate(-1);
      }}
      showHeaderItems={false}
      className={className}
    >
      <div className="flex max-h-[32px] items-center">
        <div className="flex w-full items-center justify-center text-sub2 text-primary">
          {t("cartTopNav.title")}
        </div>
      </div>
    </TopNav>
  );
};
